import { useState } from 'react';

export default function useModalState() {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalContentOption, setModalContentOption] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);

  const onOpenModal = (modalOption, tag) => {
    setIsOpenModal(true);
    setModalContentOption(modalOption);
    setSelectedTag(tag);
  };

  const onCloseModal = () => {
    setIsOpenModal(false);
    setModalContentOption(null);
    setSelectedTag(null);
  };

  return { isOpenModal, modalContentOption, selectedTag, onOpenModal, onCloseModal };
}
